<template>
  <div
    class="common-message flex items-center gap-spacing_1"
    :class="{
      disabled: disabled,
      error: error,
    }"
  >
    <CommonUIcons class="prefix-icon" :name="prefix_icon" />
    <p
      class="message line-clamp-2 w-full font-secondary text-size_4 text-neutral-800"
      aria-label="message"
    >
      {{ message }}
    </p>
    <CommonUIcons class="suffix-icon" :name="suffix_icon" />
  </div>
</template>

<script setup lang="ts">
import type { MessageProps } from "~/types/schemas/common/Atom/message";

defineProps<MessageProps>();
</script>

<style scoped>
.common-message {
  .prefix-icon,
  .suffix-icon {
    @apply h-icon_size_3 w-icon_size_3 font-medium;
  }

  .message {
    @apply font-medium;
  }

  &.disabled {
    .prefix-icon,
    .suffix-icon,
    .message {
      @apply text-neutral-500;
    }
  }

  &.error {
    .prefix-icon,
    .suffix-icon,
    .message {
      @apply text-error-200;
    }
  }
}
</style>
